var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDislikeIcon = function SvgDislikeIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 14,
    fill: "none",
    viewBox: "0 0 14 14"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M8.03 13.074a.58.58 0 0 1-.531.343 2.38 2.38 0 0 1-1.667-.68 2.32 2.32 0 0 1-.695-1.654v-1.75H2.368a1.79 1.79 0 0 1-1.348-.598A1.75 1.75 0 0 1 .604 7.32l.818-5.25c.064-.419.28-.8.606-1.072A1.78 1.78 0 0 1 3.186.583h8.462c.466 0 .915.183 1.247.51s.522.773.522 1.24v4.084c0 .467-.189.913-.522 1.24-.332.328-.781.51-1.247.51h-1.402zm1.256-5.616-2.14 4.74a1.2 1.2 0 0 1-.496-.293 1.15 1.15 0 0 1-.346-.822V8.75a.583.583 0 0 0-.584-.583H2.36a.62.62 0 0 1-.464-.204.58.58 0 0 1-.138-.466l.818-5.25a.58.58 0 0 1 .202-.355.6.6 0 0 1 .4-.142h6.11zm1.167-5.708V7h1.195a.6.6 0 0 0 .429-.174.57.57 0 0 0 .173-.41V2.334a.57.57 0 0 0-.173-.409.6.6 0 0 0-.43-.174z",
    clipRule: "evenodd"
  })));
};
export default SvgDislikeIcon;